// John Eldhose 20200626

const postAcademy = (mod, data, res) => {
  var { postData } = require('../../lib/api');
  postData('academy', { mod: mod, data: data })
    .then(res)
    .catch(res)
}

export { postAcademy };



// WEBPACK FOOTER //
// ./src/components/home/academy/lib.js